type DigitalCampaignLocation = {
  location_name?: string | null;
  state?: string | null;
  country?: string | null;
};

export const getDigitalCampaignLocationDisplayName = (
  location?: DigitalCampaignLocation | null
) =>
  [location?.location_name, location?.state, location?.country]
    .filter(
      (segment) => segment !== undefined && segment !== null && segment !== ""
    )
    .join(", ");
